if (!customElements.get('popular-products-slider')) {
  customElements.define('popular-products-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'slider' || this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-popular-track]');
      this.querySelector('[data-popular-prev]')?.addEventListener('click', () => this.move(-1));
      this.querySelector('[data-popular-next]')?.addEventListener('click', () => this.move(1));
      if (this.dataset.autoplay === 'true') this.start();
      if (this.dataset.pauseHover === 'true') {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }
    }

    disconnectedCallback() { this.stop(); }

    start() {
      if (this.dataset.autoplay !== 'true') return;
      this.stop();
      this.timer = window.setInterval(() => this.move(1), Number(this.dataset.delay) || 3000);
    }

    stop() { window.clearInterval(this.timer); }

    move(direction) {
      const card = this.track?.querySelector('.popular-product-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 20;
      const step = card.getBoundingClientRect().width + gap;
      const end = this.track.scrollWidth - this.track.clientWidth - 2;
      const target = this.track.scrollLeft + direction * step;
      this.track.scrollTo({ left: target > end ? 0 : target < 0 ? end : target, behavior: 'smooth' });
    }
  });
}
